import React from 'react'
import styles from './RideRepicker.scss'
import { RidePickerContainer } from '../../RidePicker'
import { Icon } from 'common/LegacyIcon'
import { FormattedMessage as T } from 'react-intl'

export const RideRepicker = ({ selectedRides, onConfirmSelection, onDismiss }) => (
  <div className={styles.RideRepicker}>
    <div className={styles.content}>
      <h1><T id='RideRepicker.edit' defaultMessage='Edit Rides' /></h1>
      <RidePickerContainer selectedRides={selectedRides.map(r => r.toJS())} onConfirmSelection={onConfirmSelection} />
      <div className={styles.closeButton} onClick={onDismiss}>
        <Icon i='x' size={20} />
      </div>
    </div>
  </div>
)
